import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import ProductPageHero from "components/products/ProductPageHero.js";
import MainFeature from "components/features/TwoColWithButton.js";
import Features from "components/features/ThreeColSimple.js";
import ProductLegalLinks from "components/products/ProductLegalLinks.js";
import DownloadApp from "components/cta/DownloadApp.js";
import GetStarted from "components/cta/GetStarted";
import Footer from "components/footers/FiveColumnWithBackground.js";

import VipsoIcon from "images/products/vipso/vipso-icon.png";
import VipsoScreenshot1 from "images/products/vipso/vipso-screenshot-1.png";
import SupportIcon from "images/support-icon.svg";
import ShieldIcon from "images/shield-icon.svg";
import CustomizeIcon from "images/customize-icon.svg";
import FastIcon from "images/fast-icon.svg";
import ReliableIcon from "images/reliable-icon.svg";
import SimpleIcon from "images/simple-icon.svg";
import ShopIcon from "images/shop-icon.svg";
import ServerIllustration from "images/server-illustration.svg";
import PrototypeIllustration from "images/prototype-illustration.svg";

const Subheading = tw.span`uppercase tracking-wider text-sm`;
const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.spurnest.vipso";

const moduleCards = [
  { imageSrc: ShopIcon, title: "Procurement", description: "Manage purchase and sales orders across your supply chain." },
  { imageSrc: CustomizeIcon, title: "Product Management", description: "Track products, variants, and inventory levels in real time." },
  { imageSrc: ServerIllustration, title: "Warehouse Management", description: "Monitor stock across warehouses with full visibility." },
  { imageSrc: SupportIcon, title: "Staff Management", description: "Track staff performance on purchase and sales orders." },
  { imageSrc: ShieldIcon, title: "Customer Management", description: "Maintain customer records and order history." },
  { imageSrc: ReliableIcon, title: "Vendor Management", description: "Manage vendor relationships and procurement workflows." },
  { imageSrc: FastIcon, title: "Unit Management", description: "Define and manage measurement units for products." },
  { imageSrc: SimpleIcon, title: "Invoices", description: "Generate and track invoices for all transactions." },
];

const legalLinks = [
  { label: "Privacy Policy", href: "/products/vipso/privacy-policy" },
  { label: "Terms of Service", href: "/products/vipso/terms" },
  { label: "Refund Policy", href: "/products/vipso/refund-policy" },
];

export default () => {
  return (
    <AnimationRevealPage>
      <ProductPageHero
        badge="Business"
        title="VIPSO"
        tagline="Simplify accounting, inventory, and purchase order management for your business — track every order from warehouse to customer."
        heroImage={VipsoIcon}
        primaryCtaText="Get on Google Play"
        primaryCtaUrl={GOOGLE_PLAY_URL}
        secondaryCtaText="Privacy Policy"
        secondaryCtaUrl="/products/vipso/privacy-policy"
      />
      <MainFeature
        subheading={<Subheading>Overview</Subheading>}
        heading="Complete business management in your pocket."
        imageSrc={PrototypeIllustration}
        description="VIPSO enables your organization to track every order made on your warehouse with customers and vendors. Monitor staff performance, manage inventory, and stay on top of procurement — all from a single Android app built by Spurnest Techlabs."
      />
      <Features
        subheading={<Subheading>Modules</Subheading>}
        heading="Everything your business needs."
        description="Eight integrated modules plus a powerful dashboard to track products, inventory, and orders."
        cards={moduleCards}
        linkText=""
      />
      <DownloadApp
        subheading="Download VIPSO"
        text="Available on Google Play. Start managing your inventory and orders today."
        link1Url={null}
        link2Text="Google Play"
        link2Url={GOOGLE_PLAY_URL}
        imageSrc={VipsoScreenshot1}
        pushDownFooter={true}
      />
      <ProductLegalLinks productName="VIPSO" links={legalLinks} />
      <GetStarted
        text="Need a custom business app like VIPSO?"
        primaryLinkText="Contact Us"
        primaryLinkUrl="/contact-us"
        secondaryLinkText="View All Products"
        secondaryLinkUrl="/#our-products"
      />
      <Footer />
    </AnimationRevealPage>
  );
};
